import {createSlice} from "@reduxjs/toolkit";
const initialState: {value:any[]}= {value:[]}
export const DeadManagementColumnsSlice = createSlice({
    name: 'DeadManagementColumnsSlice',
    initialState: initialState,
    reducers:{
        saveDeadManagementColumns: (state, action) => {
            state.value  = action.payload;
        },
    }
})
export const { saveDeadManagementColumns } = DeadManagementColumnsSlice.actions

export default DeadManagementColumnsSlice.reducer